import { render } from "./BrandFormView.vue?vue&type=template&id=6079b94d"
import script from "./BrandFormView.vue?vue&type=script&lang=js"
export * from "./BrandFormView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/views/BrandFormView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6079b94d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6079b94d', __exports__)) {
    api.reload('6079b94d', __exports__)
  }
  
  module.hot.accept("./BrandFormView.vue?vue&type=template&id=6079b94d", () => {
    api.rerender('6079b94d', render)
  })

}


export default __exports__